import { ETxnSpeed, MediaType, schemes, zSchema } from "@zeal/common";

const singleDateSchema = zSchema
  .object({
    companyID: schemes.companyID(),
    check_date: schemes.isoDate(),
    start_date: zSchema.undefined().optional(),
    end_date: zSchema.undefined().optional(),
    speed: zSchema.nativeEnum(ETxnSpeed).optional(),
    media_type: zSchema.nativeEnum(MediaType),
    customer_account_ids: zSchema.array(zSchema.string()).optional(),
  })
  .strict();

const dateRangeSchema = zSchema
  .object({
    companyID: schemes.companyID(),
    start_date: schemes.isoDate(),
    end_date: schemes.isoDate(),
    check_date: zSchema.undefined().optional(),
    speed: zSchema.nativeEnum(ETxnSpeed).optional(),
    media_type: zSchema.nativeEnum(MediaType),
    customer_account_ids: zSchema.array(zSchema.string()).optional(),
  })
  .strict();

export const postCashRequirementsRequestSchema = zSchema.union([
  singleDateSchema,
  dateRangeSchema,
]);

export type IPostCashRequirementsRequestBody = zSchema.infer<
  typeof postCashRequirementsRequestSchema
>;

const responseRequestSchema = postCashRequirementsRequestSchema.and(
  zSchema.object({
    job_type: zSchema.string(),
    report_format: zSchema.string(),
  })
);

export const postCashRequirementsResponseSchema = zSchema.object({
  data: zSchema.object({
    created_at: zSchema.string(),
    job_id: zSchema.string(),
    request_body: responseRequestSchema,
    status: zSchema.string(),
  }),
  status: zSchema.number(),
  success: zSchema.boolean(),
});

export type IPostCashRequirementsResponseBody = zSchema.infer<
  typeof postCashRequirementsResponseSchema
>;

export type IPostCashRequirementsResponseData =
  IPostCashRequirementsResponseBody["data"];
